import {computed, inject, Injectable, signal} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LoginRequest} from '@interfaces/login.request';
import {Customer} from '@interfaces/customer';
import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import {StoreUser} from "@interfaces/general/store";
import {MessageService} from "@services/shared/message.service";
import {EnvironmentService} from "@services/environment.service";

interface ResponseLogin {
  customer: Customer
}

@Injectable({providedIn: 'root'})
export class UserService {

  private environmentService = inject(EnvironmentService);
  public url: string = this.environmentService.getUrl();
  public http = inject(HttpClient)
  public router = inject(Router)
  public messageService = inject(MessageService)
  public authChange$ = new Subject<boolean>();

  #state = signal<StoreUser>({
    loading: true,
    user: {
      id: 0,
      dni: 0,
      name: '',
      lastName: '',
      checkingAccountEnabled: false,
      enabled: false,
      saldoFavor: 0,
      listPrice: 0,
      userName: '',
      cellphone: '',
      email: '',
      address: '',
      zipCode: 0,
      city: '',
      state: '',
      password: '',
    },
  });

  public loading = computed(() => this.#state().loading);
  public user = computed(() => this.#state().user);

  login(loginRequest: LoginRequest) {
    this.#state.set({
      ...this.#state(),
      loading: true,
    })
    return this.http.post<ResponseLogin>(this.url + 'loginService/loginCustomer2X', loginRequest).subscribe({
      next: (res: ResponseLogin) => {
        this.#state.set({
          ...this.#state(),
          loading: false,
          user: res.customer,
        })

        localStorage.setItem('identity', JSON.stringify(res.customer));
        this.authChange$.next(true);
        this.router.navigate(['/']);
      }, error: (error: any) => {
        this.initState();
        this.messageService.showMessageError('Usuario o contraseña incorrectos');
      }
    })
  }

  getCustomer() {
    const customer = localStorage.getItem('identity');
    if (customer) {
      return JSON.parse(customer);
    } else {
      return {
        id: 0,
        dni: 0,
        name: '',
        lastName: '',
        checkingAccountEnabled: false,
        enabled: false,
        saldoFavor: 0,
        listPrice: 0,
        userName: '',
        cellphone: '',
        email: '',
        address: '',
        zipCode: 0,
        city: '',
        state: '',
        password: '',
      }
    }
  }

  getIdentity() {
    const identity = JSON.parse(localStorage.getItem('identity')!);
    if (identity !== 'undefined' && identity != null) {
      const { customer } = identity;
      if (customer) {
        return customer;
      }
    }
    return null;
  }

  isAuth() {
    const token: string | null = localStorage.getItem('tknStore');
    const tokenExpiration: number = JSON.parse(localStorage.getItem('tknStore-expiration') || '0');
    const currentTime: number = new Date().getTime();
    const isTokenExpired: boolean = currentTime > tokenExpiration;

    if (token == null || token.length == 0 || !tokenExpiration || isTokenExpired) {
      this.logOut()
      return false;
    } else {
      return true;
    }

  }

  initState() {
    this.#state.set({
      ...this.#state(),
      loading: false,
      user: {
        id: 0,
        dni: 0,
        name: '',
        lastName: '',
        checkingAccountEnabled: false,
        enabled: false,
        saldoFavor: 0,
        listPrice: 0,
        userName: '',
        cellphone: '',
        email: '',
        address: '',
        zipCode: 0,
        city: '',
        state: '',
        password: '',
      },
    })
  }

  logOut() {
    localStorage.clear();
    this.authChange$.next(false);
    this.initState();
    this.router.navigate(['/'])
  }
}
